import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';

/** UX-4139: view-only gating only; command.execute is not checked here. */
export const useShutdownActionPermission = () =>
  useActionPermission({ privilege: PRIVILEGES.accessChecked });
